<template>
  <span
    v-if="crediti !== undefined && crediti !== null"
    class="crediti"
    :class="[variantClass, { 'crediti-glow': glow }]"
  >
    <v-icon v-if="useIcon" small left class="crediti-icon">{{ icon }}</v-icon>
    <span>{{ crediti }}</span>
  </span>
</template>

<script>
export default {
  name: "crediti",
  props: {
    crediti: {
      type: [String, Number],
      default: null,
    },
    severity: {
      type: String,
      default: "gold",
    },
    variant: {
      type: String,
      default: "light",
      validator: (value) =>
        ["light", "dark"].includes(
          value
        ),
    },
    useIcon: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "fa-database",
    },
    glow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    variantClass() {
      return `crediti--${this.variant}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.crediti {
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  font-size: 11px;
  font-weight: bold;
  justify-content: center;
  padding: 2px 10px;
  white-space: nowrap;
 &.crediti-horizontal {
    padding: 6px 10px;
}
}

.crediti--light {
  background: var(--my-gold-light-transparent-background);
  color: var(--my-gold-light-text);
}
.crediti--dark {
  background: var(--my-gold-dark-transparent-background);
  color: var(--my-gold-dark-text);
  background: rgba(246, 189, 0);
  // color: #654e00;
  // border: 0.8px solid var(--my-gold-dark-text);
}
.crediti-icon {
  color: currentColor;
  font-size: 11px !important;
}

.crediti-glow{
  box-shadow: 0px 0px 12px 2px rgba(246, 189, 0, 0.80);
}
</style>
